export interface ICurrentTimeFrame {
    value: number;
    title: string;
}